export default [
  {
    path: '/',
    component: () => import('@/views/LoginPage'),
    children: [
      {
        path: '',
        component: () => import('@/views/LoginPage/Login')
      },
      {
        path: '/login',
        component: () => import('@/views/LoginPage/Login')
      },
      {
        path: '/register',
        component: () => import('@/views/LoginPage/register')
      }
    ]
  }
]
